import { syncFavorite } from '../helpers/favorites';
import SeoInformation from '../SeoInformation/SeoInformation';
import { initPhone } from '../ContactsActions/ContactsPhoneButton/ContactsPhoneButton';
import Map from './map';
import './DeveloperNews/DeveloperNews';
import './Developer.scss';

syncFavorite();
SeoInformation();
initPhone(document.querySelector('#developer-external'));
new Map();
